import { IStreamInfo, EPlatformNames } from "./platforms";
import { ISubscriptionPaymentMethods, ISubscriptionTransaction } from "./subscription";

export interface IUser {
  id?: number;
  username: string;
  email: string;
  blocked: boolean;
  avatar_url?: string;
  stream_key: string;
  identifier: string;
  widget_token: string;
  availableFlags?: { [key: string]: boolean; };
  subscriptions?: any[];
  free_access?: number;
  uuid?: string;
  socketServerUrl?: string;
  hasConsentedTerms?: boolean;
  hasTwitch: boolean;
  hasYouTube: boolean;
  showGDPRCompliance?: boolean;
  identity?: IUserIdentity;
  settings?: IUserSettings;
  original_username?: string;
  twitchReauthenticationNeeded?: boolean;
  connected_accounts: any[];
  available_platforms: string[];
}

export interface IUserInformation {
  user: IUser;
  transactions?: ISubscriptionTransaction[];
  paymentMethods?: ISubscriptionPaymentMethods[];
}
export interface IUserFlag {
  project_onboarding_shown?: string;
  editor_onboarding_shown?: string;
  stream_attempt?: string;
  admin?: string;
  free_access?: string;
  do_not_show_feedback_modal?: string;
  transition_tooltip_shown?: string;
  connect_platform_dismissed?: string;
  edit_stream_info_button_dismissed?: string;
}

export enum EUserFlag {
  projectOnboardingShown = 'project_onboarding_shown',
  editorOnboardingShown = 'editor_onboarding_shown',
  streamAttempt = 'stream_attempt',
  firstSuccessfulTransaction = 'first_successful_transaction',
  doNotShowFeedbackModal = 'do_not_show_feedback_modal',
  showOnboarding = 'show_onboarding',
}

export interface IStreamSettings {
  source: string;
}

export interface IUserStreamStatus {
  status: TStreamStatus;
}

export type TStreamStatus = 'Online' | 'Offline' | 'Preview';

export type TLivePlatforms = EPlatformNames;

export enum EUserAdEvent {
  signUp = 'sign_up',
  logIn = 'console_log_in',
  purchase = 'console_purchase',
  goLive = 'console_go_live',
  cancel = 'console_cancel',
  projectCreated = 'console_project_created',
  freeTrialStarted = 'console_free_trial_started',
  purchaseSubscription = 'PurchaseSubscription'
}

export interface IIceConfig {
  urls: string[];
  username: string;
  credential: string;
  expires_at: string;
}

export interface IUserIdentity {
  email: string;
  id: string;
  username: string;
  ultra: boolean;
}

export interface IUserSettings {
  region?: string;
  marketingEmailsSubscribed?: boolean;
  streamInfo?: IStreamInfo;
}

export interface IStreamStats {
  mb_sec: number;
  time: number;
  fps: 30 | 60;
  rtmp_height: number;
}

export enum EBannerMessageType {
  error = 'error',
}

export interface IBannerMessageError {
  message: string;
  link?: string;
  link_text?: string;
}

export interface IBannerMessage {
  data: IBannerMessageError;
  type: EBannerMessageType;
}
